import React from "react";
import AboutCard from "./aboutCard";
import Work from '../../Images/New/Whay_us/Work.svg'
import Wallet from '../../Images/New/Whay_us/Wallet.svg'
import Check from '../../Images/New/Whay_us/person_check.svg'
import Bounding from '../../Images/New/Whay_us/person_bounding.svg'
import Time from '../../Images/New/Whay_us/time.svg'
import Video from '../../Images/New/Whay_us/video_1.svg'

const About = () => {
  const data = [
    {
      title: "Easy to operate",
      disc: "EasyACC offers a Comprehensive Dashboard for an all-in-one view, user-friendly interface simplifies complex tasks.",
      icon: Work,
    },
    {
      title: "Competitive Pricing",
      disc: "EasyACC unmatched efficiency at a competitive price point, delivering value without compromise.",
      icon: Wallet,
    },
    {
      title: "GST Compliant",
      disc: "EasyACC ensures seamless compliance with GST regulations.",
      icon: Check,
    },
    {
      title: "Customizable Software",
      disc: "Empower your operations with EasyAcc customizable software.",
      icon: Bounding,
    },
    {
      title: "Trusted by Accountants",
      disc: "EasyACC trusted by professional Accountants globally for its accuracy and eddiciency.",
      icon: Time,
    },
    {
      title: "Expert Team",
      disc: "Expert Tech support for EasyACC, ensuring smooth operation at every step by step.",
      icon: Video,
    },
  ];

  return (
    <div className="absolute z-40 bg-white w-full">
      <div className="max-w-7xl mx-auto py-12 px-3 sm:px-0">
        <div className="text-center">
          <h2 className="text-5xl font-bold text-gray-900">
            Why Choose{" "}
            <span
              className=""
              style={{
                backgroundImage:
                  "linear-gradient(120deg, #0077b3 0%, #00aacc 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              Us?
            </span>
          </h2>
          <p className="mt-2 text-2xl text-gray-800 italic">
            Accounting Inventory Invoicing Management Software
          </p>
        </div>
        <div className="mt-12 space-y-10 sm:space-y-0 sm:grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {data.map((item, index) => (
            <AboutCard
              key={index}
              icon={item.icon}
              title={item.title}
              disc={item.disc}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default About;
